import { render, staticRenderFns } from "./KlinikSchulVereinIcon.vue?vue&type=template&id=2ff80396"
import script from "./KlinikSchulVereinIcon.vue?vue&type=script&lang=js"
export * from "./KlinikSchulVereinIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports